import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import capitalize from 'utils/capitalize';
import countries from 'data/countries';

/*
 * Match locale to file name
 * Germany and Portugal dayjs locale file only use the first 2 characters.
 */
const LOCALE = ['de-DE', 'pt-PT'].includes(process.env.GATSBY_COUNTRY_CODE)
  ? process.env.GATSBY_COUNTRY_CODE.slice(-2).toLowerCase()
  : countries[process.env.GATSBY_COUNTRY_CODE]?.lang.toLowerCase();

require('dayjs/locale/' + LOCALE);

dayjs.locale(LOCALE);
dayjs.extend(updateLocale);
dayjs.extend(localizedFormat);

export const formatDate = date => {
  // default 'LLLL' format is: Friday, 24 February 2021 00:00
  // we need a full date without the year
  // target format: Friday, 24 February
  let dateFormat = 'dddd, D MMMM';
  if (LOCALE === 'es') dateFormat = 'dddd, D [de] MMMM';
  if (LOCALE === 'fr') dateFormat = 'dddd D MMMM';
  if (LOCALE.substring(0, 2) === 'de') dateFormat = 'dddd, D. MMMM';

  dayjs.updateLocale(LOCALE, {
    formats: {
      LLLL: dateFormat,
    },
  });

  const dateStr = dayjs(date).format('LLLL'); // friday, 24 february
  // target date string: Friday, 24 February for all locales, except france
  if (LOCALE === 'fr') return dateStr.charAt(0).toUpperCase() + dateStr.slice(1);
  else if (LOCALE === 'es') return dateStr;
  else return capitalize(dateStr);
};

export const formatTime = time => {
  if (LOCALE === 'fr') return time.replace(':', 'h').substring(0, 5);
  return time.substring(0, 5);
};

export const monthAndYear = date => {
  const year = dayjs(date).year();
  const month = dayjs(date).format('MMMM');
  return `${month}, ${year}`;
};

export const dayOfTheWeek = date => {
  // returns abbreviated day of the week
  return dayjs(date).format('dd');
};

export const dateOfTheWeek = date => {
  return dayjs(date).format('D');
};

export const getFormattedDateTime = time => {
  if (!time) return [];
  const [sdate, stime] = time?.split('T') || [];

  return [sdate, stime];
};

export const removeTFromDateTime = time => time?.replace('T', '');

export const removeZFromDateTime = time => time?.replace('Z', '');
